export default __webpack_public_path__ + "static/media/main-btcy-logo.bce58e8b.svg";